import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetDepartment, GetDeleteDepartment } from "./thunk";
import { IDepartmentInitialState, IDepartmentPayload } from "../types";

const initialState: IDepartmentInitialState = {
    departmentData: [],
    departmentRestoreData: [],
    isViewDepartmentRestore: false,
    filterDepartment: [],
    selectedDepartmentIDs: [],
    isLoadingDepartment: true,
};

const academicDepartmentSlice = createSlice({
    name: "academicDepartment",
    initialState,
    reducers: {
        setDepartment: (state, action: PayloadAction<{ data: IDepartmentPayload[]; defaultLanguage: string }>) => {
            const { data, defaultLanguage } = action.payload;

            state.departmentData = data;

            state.filterDepartment = state.departmentData.flatMap(data =>
                data.translations
                    .filter(elem => elem.slug === defaultLanguage && elem.name)
                    .map(elem => ({
                        id: data.id,
                        abbreviation: elem?.abbreviation || "",
                        name: elem.name as string,
                    }))
            );
        },
        setIsViewAcademicRestore: state => {
            state.isViewDepartmentRestore = !state.isViewDepartmentRestore;
        },

        setAcademicRestoreData: (state, action) => {
            state.departmentRestoreData = action.payload;
        },
        deletedDepartment: (state, action: PayloadAction<number>) => {
            state.departmentData = state.departmentData.filter(elem => elem.id !== action.payload);
        },
        deletedRestoreAcademic: (state, action) => {
            state.departmentRestoreData = state.departmentRestoreData.filter(elem => elem.id !== action.payload);
        },
        updateDepartment: (state, action) => {
            const { id, ...rest } = action.payload;
            state.departmentData = state.departmentData.map(elem => (elem.id === id ? { ...elem, ...rest } : elem));
        },

        setSelectedDepartmentIDs: (state, action) => {
            state.selectedDepartmentIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetDepartment.pending, state => {
                state.isLoadingDepartment = true;
            })
            .addCase(GetDepartment.fulfilled, state => {
                state.isLoadingDepartment = false;
            })
            .addCase(GetDepartment.rejected, state => {
                state.isLoadingDepartment = false;
            })
            .addCase(GetDeleteDepartment.pending, state => {
                state.isLoadingDepartment = true;
            })
            .addCase(GetDeleteDepartment.fulfilled, state => {
                state.isLoadingDepartment = false;
            })
            .addCase(GetDeleteDepartment.rejected, state => {
                state.isLoadingDepartment = false;
            });
    },
});

export const {
    setDepartment,
    setSelectedDepartmentIDs,
    updateDepartment,
    deletedDepartment,
    setIsViewAcademicRestore,
    setAcademicRestoreData,
    deletedRestoreAcademic,
} = academicDepartmentSlice.actions;

export default academicDepartmentSlice;
